import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import { canUseDOM } from "@utils/general";

export type PortalProps = {
    children?: React.ReactNode;
    node?: Element | null;
};

const Portal = ({ node, children }: PortalProps) => {
    let defaultNode: Element | null = null;
    useEffect(() => {
        return () => {
            if (defaultNode) {
                document.body.removeChild(defaultNode);
            }
            defaultNode = null;
        };
    }, []);

    if (!canUseDOM) {
        return null;
    }

    if (!node && !defaultNode) {
        defaultNode = document.createElement("div");
        document.body.appendChild(defaultNode);
    }

    return ReactDOM.createPortal(children, node || defaultNode!);
};

export { Portal };
